// extracted by mini-css-extract-plugin
export default {"page":"gX-z","cartModal":"hX-z","checkout":"iX-z","placeholder":"jX-z","account":"kX-z"};